import React from "react"
import {
  Divider,
  GameRulesConainer,
  Text,
  SubText,
  ImgBlock,
} from "./GameRulesStyles"
import solar from "./assets/solar.png"
import galactical from "./assets/galactical.png"
import stellar from "./assets/stellar.png"
import jackpotimg1 from "./assets/jackpotimg-1.png"
import jackpotimg2 from "./assets/jackpotimg-2.png"
import jackpotroundimg from "./assets/jackpotround.png"
import jackpotwinimg from "./assets/jackpotwin.png"

export default function JackpotRules() {
  return (
    <GameRulesConainer>
      <Text className={"big blue"} margin={"0 0 10px"}>
        what is jackpot?
      </Text>
      <Text className={"big white"} margin={"0 0 10px"}>
        <SubText className={"big red"}>Stellar Jackpot </SubText>
        is an innovative bonus round in the Crash game category implemented by
        <SubText className="big blue"> Orbital</SubText>, allowing the player to
        <SubText className="big green"> win a large share</SubText> of
        progressively accumulated money and making the game more{" "}
        <SubText className="big red">beneficial</SubText> and
        <SubText className="big blue"> multi-functional</SubText> on the user
        side.
      </Text>
      <Divider margin="16px 0" />
      <Text className={"big red"} margin={"0 0 10px"}>
        HOW THE JACKPOT IS COLLECTED?
      </Text>
      <Text className={"big white"} margin={"0 0 10px"}>
        <SubText className="big green">Jackpot amount</SubText> is accumulated
        globally as <SubText className="big blue">% of THE bet</SubText> and
        divided into <SubText className="big red">3 prize</SubText> pools -
        <SubText className="big green"> Solar,</SubText>
        <SubText className="big blue"> Galactical,</SubText> AND
        <SubText className="big red"> Stellar.</SubText>
      </Text>
      <Text className={"small white"} margin={"0 0 10px"}>
        *<SubText className="small green">Accumulation</SubText> IS DONE on the
        <SubText className="small red"> casino side </SubText>
        and does not affect the
        <SubText className="small blue"> player`s bet</SubText>
      </Text>
      <ImgBlock>
        <img src={solar} alt="" />
        <img src={galactical} alt="" />
        <img src={stellar} alt="" />
      </ImgBlock>
      <Divider margin="16px 0" />
      <Text className={"big green"} margin={"0 0 10px"}>
        HOW TO WIN JACKPOT?
      </Text>
      <Text className={"big white"} margin={"0 0 10px"}>
        <SubText className="big red">The Jackpot</SubText> is played
        <SubText className="big blue"> randomly,</SubText> a player must
        <SubText className="big green"> place a bet</SubText> to participate
        <SubText className="big blue"> chance</SubText> of play
        <SubText className="big red"> Jackpot round.</SubText>
      </Text>
      <Text className={"small white"} margin={"0 0 4px"}>
        *The player can win the jackpot amount only after achieving the minimum
        values for all 3 Jackpots. Also this would be the same case after
        hitting the jackpot. However, the player can get the awarded, the{" "}
        <SubText className="small blue">0.5% jackpot RTP </SubText>by achieving
        the mentiond case.
      </Text>
      <Text className={"big white"} margin={"0 0 10px"}>
        after the player
        <SubText className="big blue"> places a bet</SubText> and
        <SubText className="big red"> the jackpot round </SubText> occurs, the
        <SubText className="big green"> current round</SubText> will be
        <SubText className="big red"> canceled</SubText> at the beginning of the
        game, and the placed bet will be
        <SubText className="big green"> refunded;</SubText> the main message{" "}
        <SubText className="big red"> &quot;prepare for jackpot&quot; </SubText>
        will appear in the player`s gameplay and the
        <SubText className="big blue"> shuttle</SubText> will fly at{" "}
        <SubText className="big red"> the speed of light,</SubText> after few
        seconds, a <SubText className="big red"> black hole</SubText> will
        appear to swallow the <SubText className="big blue"> shuttle, </SubText>
        and will take it to the{" "}
        <SubText className="big blue"> &quot;tesseract&quot;</SubText> dimension
        <ImgBlock>
          <img src={jackpotimg1} alt="" />
          <img src={jackpotimg2} alt="" />
        </ImgBlock>
        After entering the{" "}
        <SubText className="big blue"> &quot;tesseract&quot;</SubText>{" "}
        dimension, the player has{" "}
        <SubText className="big green"> 9 cubes </SubText>to BREAK, each hiding
        one of the <SubText className="big red"> 3 prize pool </SubText>symbols,
        the player must match{" "}
        <SubText className="big green"> 3 of the same symbols </SubText>to win
        the jackpot corresponding to that symbol
      </Text>
      <Text className={"small white"} margin={"0 0 4px"}>
        *The jackpot round has a{" "}
        <SubText className="small blue">2 minute timer</SubText>running after
        that, it will automatically reveal all the cubes and award
        <SubText className="small green"> Solar</SubText> jackpot amount only
      </Text>
      <Text className={"small white"} margin={"0 0 4px"}>
        *After the <SubText className="small blue">jackpot</SubText> amount
        awarded, the <SubText className="small blue">jackpot</SubText> value
        resets to <SubText className="small red">0.00</SubText>
      </Text>
      <Text className={"small white"} margin={"0 0 4px"}>
        <SubText className="small red"> *WHAT IF GET DISCONNECTED? </SubText>
        -In case you encounter a
        <SubText className="small red"> connection problem </SubText> or
        accidentally
        <SubText className="small blue"> refresh the page, </SubText>The jackpot
        round will continue until the{" "}
        <SubText className="small red"> 2 minute timer </SubText> runs out; if a
        player recconects after{" "}
        <SubText className="small blue"> 2 minutes </SubText> the pot will be{" "}
        <SubText className="small green"> determined randomly.</SubText>
      </Text>
      <ImgBlock>
        <img src={jackpotroundimg} alt="" />
        <img src={jackpotwinimg} alt="" />
      </ImgBlock>
      <Text className={"big white"} margin={"0 0 4px"}>
        The <SubText className="small red"> minimum </SubText> value of Solar,
        Galactical and Stellar are
        <SubText className="small blue"> 300 USD</SubText>,
        <SubText className="small green"> 600 USD </SubText> and
        <SubText className="small red"> 900 USD</SubText>.
      </Text>
    </GameRulesConainer>
  )
}
